export enum UserType {
  CONSULTANT = 0,           // Commercialista
  COMPANY = 1,              // Azienda
  COMPANY_NO_CONSULTANT = 2 // Azienda senza commercialista associato (fatturapoint)
}

export interface MenuItem {
  id: string;
  label: string;
  route?: string;
  children?: MenuItem[];
  permissions?: UserType[];
  isActive?: boolean;
  isActiveParent?: boolean;
  isExpanded?: boolean;
}

export interface MenuState {
  activeMenuItem: string | null;
  activeMacroCategory: string | null;
  expandedCategories: string[];
}

export interface UserProfile {
  id: string;
  name: string;
  type: UserType;
  permissions: string[];
}
